import { render, staticRenderFns } from "./faqdetails.vue?vue&type=template&id=50320168"
import script from "./faqdetails.vue?vue&type=script&lang=js"
export * from "./faqdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports